document.addEventListener('click', (event) => {
  const control = event.target.closest('[data-ff-quantity]');
  if (!control) return;
  const input = control.closest('.ff-quantity-control')?.querySelector('input[name="quantity"]');
  if (!input) return;
  const min = Number(input.min) || 1;
  const max = input.max ? Number(input.max) : Infinity;
  const current = Number(input.value) || min;
  input.value = Math.min(max, Math.max(min, current + Number(control.dataset.ffQuantity)));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', (event) => {
 const select = event.target.closest('.ff-product-page select[name="id"]');
 if (!select) return;
 const page = select.closest('.ff-product-page');
 const variants = JSON.parse(page.querySelector('[data-ff-variants]').textContent);
 const variant = variants.find((item) => String(item.id) === select.value);
 if (!variant) return;
 const price = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: page.dataset.currency }).format(variant.price / 100);
 page.querySelectorAll('[data-ff-price]').forEach((element) => { element.textContent = price; });
 page.querySelectorAll('button[name="add"]').forEach((button) => { button.disabled = !variant.available; button.textContent = variant.available ? page.dataset.addLabel : page.dataset.soldLabel; });
 const stock = page.querySelector('[data-ff-stock]');
 if (stock) stock.textContent = variant.available ? page.dataset.stockLabel : page.dataset.soldLabel;
 const packet = page.querySelector('.ff-pack');
 if (packet) packet.textContent = variant.title;
 page.querySelector('input[name="quantity"]').removeAttribute('max');
 const target = new URL(window.location.href);
 target.searchParams.set('variant', variant.id);
 history.replaceState(null, '', target);
});
